import request from '@/utils/request'
import { CreditcardPostRequest } from '@/interface/api'

export const postCreditCard = (
  medicalBusinessId: string,
  customerId: string,
  data: CreditcardPostRequest
): Promise<boolean> => {
  return request({
    url: `/api/v0/customer/medical-customers/credit-cards/${medicalBusinessId}/${customerId}/`,
    method: 'POST',
    data
  })
    .then(() => true)
    .catch(error => {
      console.error(error)
      return false
    })
}
